import React, { useState, useEffect } from 'react';

interface StaticFileProps {
  filename: string;
  apiBaseUrl: string;
}

const StaticFile: React.FC<StaticFileProps> = ({ filename, apiBaseUrl }) => {
  const [fileContent, setFileContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    fetchFile();
  }, [filename]);

  const fetchFile = async () => {
    try {
      setLoading(true);
      setError('');

      // First, get the latest file with this filename from the database
      const response = await fetch(`${apiBaseUrl}/static-file/${filename}`);
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.data) {
          // Decode base64 data
          const decodedContent = atob(data.data.base64_data.split(',')[1]);
          setFileContent(decodedContent);
        } else {
          setError('File not found');
        }
      } else {
        setError('Failed to fetch file');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <pre style={{ 
      whiteSpace: 'pre-wrap', 
      fontFamily: 'monospace',
      margin: 0,
      padding: '20px',
      backgroundColor: '#f5f5f5',
      border: '1px solid #ddd',
      borderRadius: '4px'
    }}>
      {fileContent}
    </pre>
  );
};

export default StaticFile;
